import React from "react"
import {
  DailyProgressSkeletonWrapper,
  LeftCaloriesSkelton,
  SkeletonNutritionItem,
} from "./styled"
import { FlexBox } from "components/Common/FlexBox"

const NutritionSkeleton = () => {
  return (
    <FlexBox
      $gap={16}
      $direction="column"
      style={{ width: "140px", flexShrink: 0, flexGrow: 1 }}
    >
      <SkeletonNutritionItem></SkeletonNutritionItem>
      <SkeletonNutritionItem></SkeletonNutritionItem>
      <SkeletonNutritionItem></SkeletonNutritionItem>
    </FlexBox>
  )
}

const DailyProgressSkeleton = () => {
  return (
    <DailyProgressSkeletonWrapper>
      <NutritionSkeleton />
      <LeftCaloriesSkelton />
    </DailyProgressSkeletonWrapper>
  )
}

export default DailyProgressSkeleton
